import React from 'react';
import Page from 'components/misc/BasePage';
import PageHead from 'components/misc/PageHead';
import RewardAboutContent from 'pageContents/RewardAboutContent';

const RewardAbout = () => {
  return (
    <Page>
      <PageHead />
      <RewardAboutContent />
    </Page>
  );
};

export default RewardAbout;
